import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import { FilterColumnContext } from "./context";

import FilterColumn from "./FilterColumn";
import Drawer from "./Drawer";
import Button from "./Button";
import { useSpecificListPreferences } from "@common/components/SpecificPreferences/hooks";

export const ColumnDrawer = Drawer;
export const ColumnButton = Button;

const Wrapper = () => {
  const [open, setOpen] = useState(false);
  const {
    activeColumnsList,
    columnsList,
    defaultColumnsList,
    disabledForHideColumnsList,
    dispatch,
  } = useContext(FilterColumnContext);

  const [{ columnOrder, columnWidths }, setSpecificListPreferences, ,] =
    useSpecificListPreferences();

  const [columnsListState, setColumnsListState] = useState<string[]>(
    activeColumnsList ?? []
  );
  const columnsListRef = useRef<string[]>(activeColumnsList ?? []);
  const columnWidthRef = useRef<{
    [key: string]: number;
  }>(columnWidths ?? {});

  const handleResetButton = () => {
    setColumnsListState(
      defaultColumnsList ?? columnsList?.map((x) => x.key) ?? []
    );
    columnWidthRef.current = columnWidths;
    setSpecificListPreferences({
      columnWidths: {},
    });
  };
  const handleCancelButton = () => {
    setColumnsListState(columnsListRef.current);
    setSpecificListPreferences({
      columnOrder: columnsListRef.current,
    });

    setOpen(!open);
  };
  const toggleSlider = () => {
    if (open) {
      dispatch({ activeColumnsList: columnsListState });
      columnsListRef.current = columnsListState;
    }
    setOpen(!open);
  };
  const handleSelectAll = () => {
    setColumnsListState(columnsList?.map((x) => x.key) ?? []);
  };
  const handleDeselectAll = () => {
    setColumnsListState(disabledForHideColumnsList ?? []);
  };

  const handleReorder = (key: number, position: number) => {
    setColumnsListState((prevColumnsListState) => {
      const updatedColumns = [...prevColumnsListState];
      const [removedItem] = updatedColumns.splice(key, 1);
      updatedColumns.splice(position, 0, removedItem);
      return updatedColumns;
    });
  };

  useEffect(() => {
    if (!open && columnOrder.length > 0) {
      setColumnsListState(columnOrder);
      dispatch({ activeColumnsList: columnOrder });
    }
  }, [columnOrder]);

  const handleChangeSwitcher = (name: string) => {
    const newColumnsListState = [...columnsListState];

    if (columnsListState.includes(name)) {
      newColumnsListState.splice(newColumnsListState.indexOf(name), 1);
    } else {
      newColumnsListState.push(name);
    }
    setColumnsListState(newColumnsListState);
  };

  return (
    <FilterColumn
      columns={columnsList ?? []}
      checked={columnsListState}
      open={open}
      handleResetButton={handleResetButton}
      handleCancelButton={handleCancelButton}
      handleSelectAllButton={handleSelectAll}
      handleDeselectAllButton={handleDeselectAll}
      toggleSlider={toggleSlider}
      handleChangeSwitcher={handleChangeSwitcher}
      handleReorder={handleReorder}
    />
  );
};

export default Wrapper;
